import { css } from 'styled-components';

export const opacity = css`
  transition: opacity 0.1s ease-in-out;
`;

export const backgroundColor = css`
  transition: background-color 0.1s ease-in-out;
`;

export const all = css`
  transition: all 0.1s ease-in-out;
`;

export default { opacity, backgroundColor, all };
